import { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

export const useCarousel = (page) => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCarousel = async () => {
      try {
        const response = await fetch(`${API_URL}/api/admin/public/carousels/${page}`);
        if (response.ok) {
          const data = await response.json();
          // Sort by order and extract URLs
          const sortedImages = (data.images || [])
            .sort((a, b) => a.order - b.order)
            .map(img => img.url);
          setImages(sortedImages);
        }
      } catch (err) {
        setError(err.message);
        console.error('Error fetching carousel:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchCarousel();
  }, [page]);

  return { images, loading, error };
};

export default useCarousel;
